import type { TAsrModelSelectionSource } from 'app/API/custom/asr-execution/types';

const MODEL_SELECTION_SOURCE_LABELS: Record<TAsrModelSelectionSource, string> = {
  'proxy-default': 'ASR Proxy default',
  'organization-setting': 'Organization setting',
  'resubmit-override': 'Resubmit option',
  'explicit-request': 'Request option',
};

export const getModelSelectionSourceLabel = (source: TAsrModelSelectionSource | undefined): string =>
  source ? MODEL_SELECTION_SOURCE_LABELS[source] : 'Not recorded';
